// All business quizzes in display order, shared by the quiz chips, the
// dashboard and the top-bar ticker. A quiz with a route key is live where
// that route exists; the others are teased as "coming soon".
import { Calculator, Car, FileText, HandCoins, Hourglass, Package, TrendingUp, Users, type LucideIcon } from 'lucide-react';
import type { QuizKind } from './routes';

export const QUIZZES: ReadonlyArray<{ key: string; icon: LucideIcon; routeKey?: QuizKind }> = [
  { key: 'rate', icon: Calculator, routeKey: 'rateQuiz' },
  { key: 'employee', icon: Users, routeKey: 'employeeQuiz' },
  { key: 'vehicle', icon: Car, routeKey: 'vehicleQuiz' },
  { key: 'quote', icon: FileText, routeKey: 'quoteQuiz' },
  { key: 'material', icon: Package, routeKey: 'materialQuiz' },
  { key: 'hire', icon: TrendingUp, routeKey: 'hireQuiz' },
  { key: 'freeWork', icon: HandCoins, routeKey: 'freeWorkQuiz' },
  { key: 'payer', icon: Hourglass, routeKey: 'latePayerQuiz' },
];
